import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import OdataGraphViewerButton from "../odata-graph-viewer-button";
import OdataViewer from "../odata-viewer";
import {languageSelector, languagesSelector} from "../../state/app/appSelectors";
import {getDecoratedResource} from "../../utils/catalog";
import {localizeI18nObj} from "../../utils/i18n";

const OdataViewItem = ({item, showTitle, enableAutoSecondaryDim = false}) => {
  const language = useSelector(languageSelector);
  const languages = useSelector(languagesSelector);

  const layouts = useMemo(() => {
    const itemLayouts = item?.layouts ? JSON.parse(item.layouts) : {};
    if (item.resourceInfo) {
      const resource = getDecoratedResource(item.resourceInfo, item.resourceId);
      itemLayouts.baseurl = resource.baseurl;
      itemLayouts.datasource = resource.datasource;
      itemLayouts.mainentityset = resource.mainentityset;
    }
    return itemLayouts;
  }, [item]);

  return (
    <OdataViewer
      {...layouts}
      filterParams={layouts?.queryParams?.filterParams}
      groupByParams={layouts?.queryParams?.groupByParams}
      selectParams={layouts?.queryParams?.selectParams}
      config={{
        ...layouts?.config,
        nodeId: item.nodeId,
        showTitle: showTitle,
        disableInteractions: true,
        disableSettings: true,
        disableWheelZoom: true,
        decimalSeparator: localizeI18nObj(item?.decimalSeparator, language, languages),
        decimalNumber: item?.decimalNumber,
        roundingStrategy: item?.roundingStrategy,
        enableAutoSecondaryDim: enableAutoSecondaryDim,
        rightActions: layouts?.query && (
          <OdataGraphViewerButton
            baseurl={layouts?.baseurl}
            datasource={layouts?.datasource}
            mainentityset={layouts?.mainentityset}
            query={layouts?.query}
          />
        )
      }}
      title={localizeI18nObj(item.title, language, languages)}
    />
  );
};

export default OdataViewItem;
